import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { UserStore } from '../store/user.store';

/**
 * Gates `/dashboard/erp` to users who can actually use it. Mirrors the
 * backend permission model: system admins or members of
 * GROUP_ERP_Administrator. Anyone else is redirected to the main
 * dashboard rather than landing on a page that 403s every API call.
 */
@Injectable({ providedIn: 'root' })
export class ErpDashboardGuard implements CanActivate {
  private userStore = inject(UserStore);
  private router = inject(Router);

  canActivate(): boolean | UrlTree {
    const userInfo = this.userStore.userInfo();
    const isSystemAdmin = userInfo?.userInfo?.userSettings?.isSystemAdmin || false;
    if (isSystemAdmin) return true;
    const roles = this.userStore.activeProfile()?.roles || [];
    if (roles.includes('SYSTEM_ADMIN') || roles.includes('GROUP_ERP_Administrator')) {
      return true;
    }
    return this.router.createUrlTree(['/dashboard']);
  }
}
